<template>
  <BaseModalConfirm
    ref="BaseModalConfirmRef"
    :value="get_isShowLimitsExceededModal"
    :title="$t('limits.exceededTitle')"
    :text="$t('limits.exceededText')"
    :svg="{ name: 'alertio/danger', style: { color: 'var(--warning-500)'} }"
    no-click-outside
    horizontal-buttons
    @close="closeModal"
  >
    <template #default="{ isOpen }">
      <div v-if="isOpen" class="wrap">
        <!--BE error reset_limit_сountdown-->
        <UiTimer
          v-if="get_gameExceededLimits"
          :end-diff="get_gameExceededLimits.reset_limit_сountdown"
          :text="$tc('limits.exceededContinue')"
          class="timer"
        />
        <LimitsModalTable v-if="limitData.length" :table="limitData" />
      </div>
    </template>

    <template #controls>
      <UiBtn
        color="gray"
        full-width
        :text="$t('limits.exceededCancel')"
        @click="toLimits"
      />
      <UiBtn
        color="primary"
        full-width
        :text="$t('limits.exceededSubmit')"
        @click="toHome"
      />
    </template>
  </BaseModalConfirm>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BaseModalConfirm from '@/components/Base/Modal/Confirm'
import LimitsModalTable from '@/components/Limits/Modal/LimitsModalTable'
import UiTimer from '~/components/ui/UiTimer'
import { secToHours } from '@/util/helpers/time'

export default {
  name: 'LimitsModalExceeded',
  components: {
    BaseModalConfirm,
    LimitsModalTable,
    UiTimer,
  },
  computed: {
    ...mapGetters('limits', ['get_gameExceededLimits']),
    ...mapGetters('game', ['get_isShowLimitsExceededModal']),
    limitData() {
      if (!this.get_gameExceededLimits) return []
      const limit = this.get_gameExceededLimits.limit
      const usedLimit = this.get_gameExceededLimits.used_limit

      return [
        { icon: 'profile/money', label: this.$t('limits.exceededItems.prop1'), value: `${secToHours(usedLimit)} / ${secToHours(limit)} ${this.$t('limits.sportHour')}` },
        { icon: 'profile/calendar', label: this.$t('limits.exceededItems.prop2'), value: this.$t(`limits.timeTabs.${this.get_gameExceededLimits.delimiter}`) },
      ]
    },
  },
  watch: {
    get_gameExceededLimits(val) {
      val && this.$open()
    },
  },
  beforeDestroy() {
    this.act_gameExceededLimits(null)
  },
  methods: {
    ...mapActions('limits', [
      'act_gameExceededLimits',
    ]),
    closeModal() {
      this.act_gameExceededLimits(null)
      this.toHome()
    },
    toLimits() {
      const param = { path: this.$paths.profileSettings }
      if (!this.$device.isDesctop) param.query = { tab: 'limits' }
      this.$router.push(param)
    },
    toHome() {
      this.$router.push({ path: this.$paths.home })
    },
    $open() {
      this.$refs.BaseModalConfirmRef.$open()
    },
    $close() {
      this.$refs.BaseModalConfirmRef.$close()
    },
  },
}
</script>

<style lang="scss" scoped>
.wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: var(--spaces-l);
}

.base-modal-confirm__image {
  margin-bottom: 0;
}
</style>
